import { MedleyCanvas } from "./MedleyCanvas";

// "Medley": a blank canvas at a summer evening table → pours → the visitor plays → the beat and the painting.
export const medley = {
  slug: "medley",
  duration: 29,
  music: "electro-cabello",
  musicAt: 15,
  beat: { bpm: 120, from: 17 },
  tilt: { from: 10.5, until: 19 },
  stages: [
    { id: "canvas", at: 0, hint: "a blank canvas" },
    { id: "pour", at: 3.5, hint: "the colours pour" },
    { id: "play", at: 10.5, hint: "drag the paint · tap to blow" },
    { id: "settle", at: 19, hint: "play for play's sake" },
  ],
  line: { text: "Play for play's sake: the freedom to explore who I'm becoming.", from: 19.5, to: 28.5, pos: "low" },
  canvas: {
    w: 2.4, h: 1.26, y: 0.9, z: -1.75,
    play: [10.5, 19], settle: [20, 26],
    pours: [
      { at: [0.32, 0.55], r: 0.22, t: 3.8, color: "#C8242C" },
      { at: [0.68, 0.42], r: 0.2, t: 5.4, color: "#1F5FD0" },
      { at: [0.5, 0.7], r: 0.16, t: 7, color: "#F4F1EA" },
      { at: [0.45, 0.3], r: 0.2, t: 8.4, color: "#2E2A30" },
    ],
  },
  extra: MedleyCanvas,
  ambient: null,
  look: { start: -0.42, lift: [24, 27], end: -0.36, yaw: [[0, 0], [29, 0]] },
  calm: { duration: 12, fade: [4, 8.5], line: [5.5, 11.5], backdrop: "canvas", pos: "low" },
  speed: [[0, 0.1], [29, 0.1]],
  frag: `
uniform float uT, uRadius, uSurface, uPulse;
varying vec3 vPos;
${"__NOISE__"}
void main(){
  float n = snoise(vec3(vPos * 0.5)) * 0.5 + 0.5;
  float th = atan(vPos.x, -vPos.z);
  vec3 col;
  float glow = 0.85 + 0.15 * smoothstep(0.0, 3.5, uT);
  if (uSurface < 0.5) {
    float y = vPos.y;
    col = mix(vec3(0.98, 0.78, 0.76), vec3(0.95, 0.66, 0.7), smoothstep(0.5, 7.0, y) + n * 0.15);
    // a west window behind the table: the summer evening pouring in pink and gold
    float win = smoothstep(0.62, 0.58, abs(th)) * smoothstep(1.4, 1.6, y) * smoothstep(4.4, 4.2, y);
    vec3 sky = mix(vec3(1.0, 0.72, 0.5), vec3(0.98, 0.55, 0.68), smoothstep(1.5, 4.3, y));
    col = mix(col, sky, win * 0.85);
  } else if (uSurface < 1.5) {
    col = mix(vec3(0.62, 0.44, 0.38), vec3(0.72, 0.52, 0.45), n);
  } else {
    col = vec3(0.99, 0.86, 0.85);
  }
  vec3 pink = vec3(1.0, 0.45, 0.68);
  col = mix(col, col * pink * 1.35, 0.12 + 0.28 * uPulse);
  gl_FragColor = vec4(clamp(col * glow, 0.0, 1.0), 1.0);
  #include <colorspace_fragment>
}`,
};
